module.exports = __webpack_public_path__ + "assets/img/myLogo.98fff4ee.png";